export const INVOICE_DOWNLOAD_SERVICE_DETAIL_LINK =
  'https://biz.moneyforward.com/ai-agent#anchor-invoice-download';
export const AI_AGREEMENT_URL = 'https://biz.moneyforward.com/ai-agreement/';
